export const ACCESS_API = "v1/admin/permissions";
